(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("search-input");
  const suggestionsBox = document.getElementById("search-suggestions");
  const suggestionList = document.getElementById("suggestion-list");

  input.addEventListener("input", function () {
    const query = input.value.trim();

    if (query.length < 2) {
      suggestionsBox.classList.add("hidden");
      return;
    }

  fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[options][unavailable_products]=hide&resources[options][limit]=5`)
  .then((res) => res.json())
 .then((data) => {
  const products = data.resources.results.products || [];
  const articles = data.resources.results.articles || [];
  const pages = data.resources.results.pages || [];

  let html = "";

  // --- Products ---
  if (products.length) {
    html += `<li class="p-2 font-semibold text-gray-500">Products</li>`;
    html += products
      .map(
        (item) => `
        <li>
          <a href="${item.url}" class="flex items-center gap-3 p-3 hover:bg-gray-100 transition">
            <img src="${item.image}" alt="${item.title}" class="w-12 h-12 object-cover rounded">
            <span class="text-gray-800">${item.title}</span>
          </a>
        </li>
      `
      )
      .join("");
  }

  // --- Articles grouped by blog title ---
  if (articles.length) {
  // Group articles by blog
  const groupedByBlog = {};
    const blogMap = {
    "/blogs/luna": "Blogs",
    "/blogs/recipes": "Recipes",
  };

  articles.forEach((article) => {
    // Use blog_id as the grouping key
    const match = article.url.match(/^\/blogs\/([^/]+)/);
    const blogHandle = match ? match[1] : "default";
    const blogTitle = blogMap[`/blogs/${blogHandle}`] || blogHandle;

    if (!groupedByBlog[blogTitle]) {
      groupedByBlog[blogTitle] = [];
    }
    groupedByBlog[blogTitle].push(article);
  });

  // Render each blog group
  Object.keys(groupedByBlog).forEach((blogTitle) => {
    html += `<li class="p-2 font-semibold text-gray-500">${blogTitle}</li>`;
    html += groupedByBlog[blogTitle]
      .map(
        (article) => `
        <li>
          <a href="${article.url}" class="block p-3 hover:bg-gray-100 transition">
            <span class="text-gray-800">${article.title}</span>
          </a>
        </li>
      `
      )
      .join("");
  });
}


  // --- Pages ---
  if (pages.length) {
    html += `<li class="p-2 font-semibold text-gray-500">Pages</li>`;
    html += pages
      .map(
        (item) => `
        <li>
          <a href="${item.url}" class="block p-3 hover:bg-gray-100 transition">
            <span class="text-gray-800">${item.title}</span>
          </a>
        </li>
      `
      )
      .join("");
  }

  // Final render
  suggestionList.innerHTML = html || `<li class="p-3 text-gray-500">No results found</li>`;
  suggestionsBox.classList.remove("hidden");
})


  .catch((err) => {
    console.error("Predictive search error:", err);
  });

  });

  // Hide suggestions when clicking outside
  document.addEventListener("click", function (e) {
    if (!suggestionsBox.contains(e.target) && e.target !== input) {
      suggestionsBox.classList.add("hidden");
    }
  });
});



  // Rotating placeholders
 // Rotating placeholders
document.addEventListener("DOMContentLoaded", function() {
  const input = document.getElementById("search-input");

  const staticText = "Search For "; // stays still
  const words = ["blogs...", "recipes...", "products..."]; // rotating words

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let speed = 120; // typing speed
  let pause = 1000; // pause before deleting (ms)

  function typeEffect() {
    const currentWord = words[wordIndex];

    if (isDeleting) {
      charIndex--;
    } else {
      charIndex++;
    }

    input.setAttribute("placeholder", staticText + currentWord.substring(0, charIndex));

    if (!isDeleting && charIndex === currentWord.length) {
      // word finished typing → pause before deleting
      setTimeout(() => {
        isDeleting = true;
        typeEffect();
      }, pause);
      return; // stop here so we don't immediately continue
    } 
    
    if (isDeleting && charIndex === 0) {
      // finished deleting → move to next word
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
    }

    setTimeout(typeEffect, speed);
  }

  typeEffect();
});



  // Voice search (Web Speech API)
  const voiceBtn = document.getElementById("voice-btn");
  if (voiceBtn && 'webkitSpeechRecognition' in window) {
    const recognition = new webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = false;
    recognition.interimResults = false;

    voiceBtn.addEventListener("click", () => {
      recognition.start();
    });

    recognition.onresult = function(event) {
      document.getElementById("search-input").value = event.results[0][0].transcript;
    };
  }

  } catch(e) { console.error(e); }
})();
})();
